import { useGLTF,useTexture } from '@react-three/drei'
import { LinearEncoding } from '@react-three/drei/helpers/deprecated'

export default function Coffee(props) {
  const { nodes, materials } = useGLTF('./models/coffee_v02.gltf')
  const colors = props.colors
  const [matCap] = useTexture([
    'img/matcap2.jpg'
  ])

 
  return (

    <group {...props} dispose={null}>
    <mesh

      geometry={nodes.CoffeeShadow.geometry}
      material={materials['Mat.1']}
      position={[0, 0, -0.026]}
      >
      <meshBasicMaterial color={props.isDark?colors.shadowNight:colors.shadowDay}/>
    </mesh>
    <mesh

      geometry={nodes.coffee_lid_1.geometry}
      material={materials.coffee_lid}
      position={[0, 0.117, 0]}
      >
      <meshMatcapMaterial matcap={matCap} color={props.isDark?colors.night:colors.day} />
    </mesh>
    <mesh

      geometry={nodes.coffee_body_1.geometry}
      material={materials.coffee_body}
      >
      <meshMatcapMaterial matcap={matCap} color={props.isDark?colors.night:colors.day}/>
    </mesh>
  </group>
  )
}

useGLTF.preload('./models/coffee_v02.gltf')


/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

